<template>
  <div>
    <v-toolbar dense color="secondary" flat dark fixed>
      <v-toolbar-title>실시간 채팅</v-toolbar-title>
      <v-spacer/>

    </v-toolbar>
    <v-list three-line>
      <v-subheader class="text-center" v-if="items.length < $store.state.message.public.totalCount">
        <v-btn @click="subscribe" color="accent" text block>더보기</v-btn>
      </v-subheader>

      <v-list-item v-for="(item, i) in items" :key="i">
        <v-list-item-avatar>
          <v-img v-if="item.photoURL" :src="item.photoURL"></v-img>
          <v-icon v-else>mdi-lock-open</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-subtitle class="body-1 black--text">
            <v-tooltip bottom v-if="item.text.length > 40">
              <template v-slot:activator="{ on }">
                <span v-on="on" v-text="item.text"></span>
              </template>
              <span v-text="item.text"></span>
            </v-tooltip>
            <span v-else v-text="item.text"></span>
          </v-list-item-subtitle>
          <v-list-item-subtitle><display-time :time="item.createdAt"></display-time></v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action v-if="$store.state.fireUser && $store.state.fireUser.uid === item.uid">
          <v-btn icon @click="remove(item)" color="error"><v-icon>mdi-delete</v-icon></v-btn>
        </v-list-item-action>
      </v-list-item>
      <!-- <v-list-item/>
      <v-list-item/> -->
    </v-list>
    <v-sheet :height="blankHeight"></v-sheet>
    <v-footer fixed absolute color="transparent" padless ref="footer">
        <v-list color="">
          <v-divider class="mb-2"/>
          <v-list-item>
            <v-list-item-content>
              <v-sheet>
                <v-text-field
                  outlined
                  append-icon="mdi-send"
                  placeholder="아무 글이나~"
                  hide-details
                  @keypress.enter="save"
                  @click:append="save"
                  v-model="comment"
                ></v-text-field>
              </v-sheet>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$vuetify.breakpoint.xs">
            <v-list-item-content>
              <v-alert type="info" border="left">아이폰X 이상에서 나오는 버그 때문에 만든 공간</v-alert>
            </v-list-item-content>
          </v-list-item>
        </v-list>
    </v-footer>
  </div>
</template>
<script>
import DisplayTime from '@/components/display-time'

export default {
  components: { DisplayTime },
  props: ['room', 'drawer'],
  data () {
    return {
      unsubscribe: null,
      docs: [],
      items: [],
      comment: '',
      ref: null,
      loading: false,
      limit: 5,
      blankHeight: 0
    }
  },
  watch: {
    drawer (n, o) {
      if (n) {
        this.limit = 5
        this.subscribe()
        return
      }
      if (this.unsubscribe) this.unsubscribe()
    }
  },
  computed: {
    // blankHeight () {
    //   if (!this.drawer) return 0
    //   if (!this.$refs.footer) return 0
    //   console.log(this.$refs.footer.$el.clientHeight)
    //   return this.$refs.footer.$el.clientHeight
    // }
  },
  created () {
    // this.subscribe()
    this.refComments = this.$firebase.firestore().collection('messages').doc(this.room).collection('comments')
  },
  mounted () {
    this.blankHeight = this.$refs.footer.$el.clientHeight
  },
  destroyed () {
    if (this.unsubscribe) this.unsubscribe()
  },
  methods: {
    onError (e) {
      this.loading = false
      this.$toast.error(e.message)
    },
    subscribe () {
      this.loading = true

      this.unsubscribe = this.refComments.orderBy('createdAt', 'asc').limitToLast(this.limit).onSnapshot((sn) => {
        this.loading = false
        if (this.limit < 100) this.limit += 5
        if (sn.empty) {
          this.items = []
          return
        }
        this.$store.commit('setMessageReadCount', { collection: 'public', count: this.$store.state.message.public.totalCount })
        this.docs = sn.docs
        this.items = sn.docs.map(doc => {
          const item = doc.data()
          item.id = doc.id
          item.createdAt = item.createdAt.toDate()
          item.updatedAt = item.updatedAt.toDate()
          return item
        })
      }, this.onError)
    },
    save () {
      if (!this.comment) throw Error('빈 글은 허용하지 않습니다')
      if (this.comment.length > 80) throw Error('80 글자 이내여야 합니다')
      if (!this.$store.state.fireUser) throw Error('로그인해야 작성됩니다')
      try {
        const uid = this.$store.state.fireUser ? this.$store.state.fireUser.uid : null
        const email = this.$store.state.fireUser ? this.$store.state.fireUser.email : null
        const photoURL = this.$store.state.fireUser ? this.$store.state.fireUser.photoURL : null
        const comment = {
          uid,
          email,
          photoURL,
          text: this.comment,
          createdAt: new Date(),
          updatedAt: new Date()
        }
        this.refComments.add(comment)
      } finally {
        this.comment = ''
      }
    },
    async remove (item) {
      const r = await this.$swal.fire({
        title: '정말 삭제하시겠습니까?',
        text: '삭제 후 되돌릴 수 없습니다.',
        icon: 'error',
        // confirmButtonText: 'Cool',
        showCancelButton: true
      })
      if (!r.value) return
      await this.refComments.doc(item.id).delete()
    }
  }
}
</script>
